import React from 'react';

export default class SparePartsFinderAddToBasket extends React.Component {
    render() {
        if (this.props.isInBasket) {
            return this.renderAdded();
        } else {
            return this.renderNotAdded();
        }
    }

    renderNotAdded = () => (
        <td className="add-to-cart --not-added">
            <span onClick={this.props.onAddToBasketClick}>{__('Add to basket')}</span>
        </td>
    )

    renderAdded = () => (
        <td className="add-to-cart --added">
            <span>&#10004; {__('Item added')}</span>
        </td>
    )
}